
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 11C1.44444 11 0.972222 10.8056 0.583333 10.4167C0.194444 10.0278 0 9.55556 0 9V2C0 1.44444 0.194444 0.972222 0.583333 0.583333C0.972222 0.194444 1.44444 0 2 0H9C9.55556 0 10.0278 0.194444 10.4167 0.583333C10.8056 0.972222 11 1.44444 11 2V9C11 9.55556 10.8056 10.0278 10.4167 10.4167C10.0278 10.8056 9.55556 11 9 11H2ZM2 24C1.44444 24 0.972222 23.8056 0.583333 23.4167C0.194444 23.0278 0 22.5556 0 22V15C0 14.4444 0.194444 13.9722 0.583333 13.5833C0.972222 13.1944 1.44444 13 2 13H9C9.55556 13 10.0278 13.1944 10.4167 13.5833C10.8056 13.9722 11 14.4444 11 15V22C11 22.5556 10.8056 23.0278 10.4167 23.4167C10.0278 23.8056 9.55556 24 9 24H2ZM15 11C14.4444 11 13.9722 10.8056 13.5833 10.4167C13.1944 10.0278 13 9.55556 13 9V2C13 1.44444 13.1944 0.972222 13.5833 0.583333C13.9722 0.194444 14.4444 0 15 0H22C22.5556 0 23.0278 0.194444 23.4167 0.583333C23.8056 0.972222 24 1.44444 24 2V9C24 9.55556 23.8056 10.0278 23.4167 10.4167C23.0278 10.8056 22.5556 11 22 11H15ZM15 24C14.4444 24 13.9722 23.8056 13.5833 23.4167C13.1944 23.0278 13 22.5556 13 22V15C13 14.4444 13.1944 13.9722 13.5833 13.5833C13.9722 13.1944 14.4444 13 15 13H22C22.5556 13 23.0278 13.1944 23.4167 13.5833C23.8056 13.9722 24 14.4444 24 15V22C24 22.5556 23.8056 23.0278 23.4167 23.4167C23.0278 23.8056 22.5556 24 22 24H15ZM2 9H9V2H2V9ZM15 9H22V2H15V9ZM15 22H22V15H15V22ZM2 22H9V15H2V22Z","fill":"#1C1D20"}})])
          )
        }
      }
    